//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import date from '@/utils/date'
export default {
    data() {
        return {
            info: {},
            img: ''
        }
    },
    created() {
        this.getOrderInfo()  
    },
    computed: {
        title() {
            return '寬頻1+N'
        }
    },
    methods: {
        date,
        toView() {  // 繼續辦理
            let query = this.$session.get("broadbandRouteQuery"); // 獲取url參數信息
            this.$router.push({
                name: 'UmallBroadbandConfirm',
                query: {
                    ...query
                }
            })
        },
        backHome() {    // 退出
            let url = location.href.replace(/8081/, '8080').split('/resultUmallBroadband')[0].replace(/web\/pc/, 'web/app');
            window.location.href = `${url}/broadbandBoss/oneNAddress`;
        },  
        getOrderInfo() {
            let { orderId, info } = this.$route.query
            if(info) {
                this.info = JSON.parse(info)
                this.img = require(`@/assets/images/pc/orderStatus_big_${this.info.orderStatus}.png`)
                return
            }
            return this.$http('order/getOrderInfo', {mainOrderId: orderId,orgId:this.$client.orgid,shopId:this.$client.shopid,userId:this.$client.userid,}).then(res=>{
                if(res.returnCode == 1000) {
                    this.info = res.dataInfo
                    let _img;
                    if(this.$route.params.status == 'info') _img = this.info.orderStatus
                    else _img = (this.$route.params.status == 'success' ? '4' : '1')
                    this.img = require(`@/assets/images/pc/orderStatus_big_${_img}.png`)
                }
            })
        }
    }
}
